import script from "./product1View.vue?vue&type=script&setup=true&lang=js"
export * from "./product1View.vue?vue&type=script&setup=true&lang=js"

import "./product1View.vue?vue&type=style&index=0&id=5a71ce67&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a71ce67"]])

export default __exports__